import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectedSeat } from 'src/app/2dmap/types';
import { SelectedSeatItemComponent } from '../selected-seat-item/selected-seat-item.component';

@Component({
  selector: 'seat-selection-summary',
  standalone: true,
  templateUrl: './seat-selection-summary.component.html',
  styleUrls: ['./seat-selection-summary.component.css'],
  imports: [CommonModule, SelectedSeatItemComponent],
})
export class SeatSelectionSummaryComponent {
  @Input() selectedSeats: SelectedSeat[] = [];
  @Input() expanded = false;
  @Output() goToCheckout = new EventEmitter();
  @Output() onClose = new EventEmitter();
  @Output() onOpen = new EventEmitter();

  get subTotal() {
    return this.selectedSeats.reduce((prev, ac) => (prev += ac.price), 0);
  }

  toggle() {
    if (this.expanded) {
      this.onClose.emit();
    } else {
      this.onOpen.emit();
    }

    this.expanded = !this.expanded;
  }
}
